import {
  FaBoxes,
  FaCheckCircle,
  FaTruck,
  FaHeadset,
} from "react-icons/fa"

import SectionTitle from "../common/SectionTitle"

const advantages = [
  {
    icon: <FaBoxes size={28} />,
    title: "Large choix de produits",
    description:
      "Des centaines de références en mercerie, tissus, fermetures, fils, élastiques et accessoires pour répondre à tous les besoins professionnels.",
  },
  {
    icon: <FaCheckCircle size={28} />,
    title: "Qualité sélectionnée",
    description:
      "Nous sélectionnons rigoureusement nos produits afin de garantir fiabilité, durabilité et satisfaction à nos clients.",
  },
  {
    icon: <FaTruck size={28} />,
    title: "Disponibilité rapide",
    description:
      "Un stock adapté aux besoins des professionnels pour assurer un approvisionnement rapide et régulier.",
  },
  {
    icon: <FaHeadset size={28} />,
    title: "Accompagnement client",
    description:
      "Notre équipe vous conseille dans le choix des produits les plus adaptés à votre activité.",
  },
]

export default function WhyChooseUs() {
  return (
    <section className="py-16 lg:py-24 bg-gray-50">
      <div className="container mx-auto px-4 lg:px-8">

        <SectionTitle
          badge="Pourquoi Nous Choisir"
          title="Un partenaire de confiance pour vos fournitures textiles"
          description="Nous accompagnons les professionnels du textile avec des produits de qualité, un service réactif et une large disponibilité."
        />

        <div className="grid gap-6 md:grid-cols-2 xl:grid-cols-4 mt-12">

          {advantages.map((item) => (
            <article
              key={item.title}
              className="
                bg-white
                p-8
                rounded-2xl
                border
                border-gray-100
                shadow-sm
                hover:shadow-lg
                transition-all
                duration-300
              "
            >
              <div className="w-14 h-14 rounded-xl bg-blue-50 text-blue-600 flex items-center justify-center mb-5">
                {item.icon}
              </div>

              <h3 className="text-xl font-bold text-gray-900 mb-3">
                {item.title}
              </h3>

              <p className="text-gray-600 leading-relaxed">
                {item.description}
              </p>
            </article>
          ))}

        </div>

      </div>
    </section>
  )
}